import { render, staticRenderFns } from "./ReplacementTextTable.vue?vue&type=template&id=1b232089&"
import script from "./ReplacementTextTable.vue?vue&type=script&lang=ts&"
export * from "./ReplacementTextTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports